import './BoxRow.css';

type BoxRowProps = {
  children?: React.ReactNode
  header?: boolean
}

export const BoxRow:React.FC<BoxRowProps> = ({header, children}: BoxRowProps) => {
  return (
    <section className={`BoxRow${header ? " header": ""}`}>
      {children}
    </section>
  )
}